import BreadCrumbs from 'components/breadcrumbs'
import CustomButton from 'components/Buttons/CustomButton'
import LoadingAnimation from 'components/LoadingAnimation'
import LoadingV2 from 'components/LoadingV2'
import { getMetaContent } from 'helpers'
import { useSnackbar } from 'notistack'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'
import { Card, Input } from 'reactstrap'
import { confirmTnc, getTnc } from './tncAction'

const Tnc = () => {
  const dispatch = useDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const dataState = location.state
  const { enqueueSnackbar } = useSnackbar()
  const { tnc, loading } = useSelector((s) => s.tnc)
  const [agree, setAgree] = useState(false)
  const { profile } = useSelector((s) => s.dashboard)

  const handleConfirm = async () => {
    const resp = await dispatch(
      confirmTnc({
        ...dataState,
        version: Number(tnc?.headers?.['tnc-version']),
      }),
    )
    if (resp?.error) {
      enqueueSnackbar(resp?.payload, { variant: 'error' })
    } else {
      // navigate('/homepage', { replace: true })
      navigate('/', { replace: true })
    }
  }

  useEffect(() => {
    dispatch(getTnc())
  }, [])

  return (
    <div className="w-100 px-3">
      <style>{`
        .tnc-container-custom {
          width: 100%;
          overflow-x: hidden;
        }
        .tnc-container-custom .legal-document {
          margin-left: 0 !important;
          margin-right: 0 !important;
          max-width: 100% !important;
          width: 100% !important;
          min-height: auto !important;
          box-sizing: border-box !important;
        }
        .tnc-container-custom .legal-numbered-label {
          white-space: nowrap !important;
          width: auto !important;
          display: inline-block !important;
        }
        .tnc-container-custom .legal-numbered-row {
          word-break: normal !important;
          overflow-wrap: break-word !important;
        }
        .tnc-container-custom p,
        .tnc-container-custom div,
        .tnc-container-custom span {
          max-width: 100% !important;
          box-sizing: border-box !important;
        }
      `}</style>
      <div className="mt-3">
        <BreadCrumbs breadCrumbActive="Syarat dan ketentuan" />
      </div>

      <Card className="mb-3 border-0 shadow-none">
        <div
          className="d-flex flex-column w-100 flex-grow-1 p-3"
          style={{
            overflowY: 'auto',
            overflowX: 'hidden',
            maxWidth: '100%',
            minHeight: '60vh',
          }}
        >
          <div className="d-flex justify-content-center align-items-center my-2">
            <img
              alt={`${getMetaContent('og:title')} logo`}
              src={getMetaContent('og:image')}
              style={{ width: '100%', maxWidth: '150px', height: 'auto' }}
            />
          </div>

          {loading ? (
            <LoadingV2 size="sm" />
          ) : (
            <>
              <div className="tnc-container-custom w-100 py-2 px-1">
                <div dangerouslySetInnerHTML={{ __html: tnc?.data }} />
              </div>

              {dataState && (
                <>
                  <div className="d-flex justify-content-start align-items-start my-auto flex-row gap-2 mb-3">
                    <Input type="checkbox" onChange={() => setAgree(!agree)} />{' '}
                    <small>
                      Saya{' '}
                      <span style={{ fontWeight: 'bold' }}>
                        ({profile?.name}){' '}
                      </span>
                      menyetujui syarat dan ketentuan yang berlaku.
                    </small>
                  </div>
                  <div className="d-flex align-items-start justify-content-start flex-row">
                    <CustomButton
                      color="primary"
                      onClick={handleConfirm}
                      disabled={!agree || loading}
                    >
                      Konfirmasi
                    </CustomButton>
                    {loading ? <LoadingAnimation size="sm" /> : null}
                  </div>
                </>
              )}
            </>
          )}
        </div>
      </Card>
    </div>
  )
}

export default Tnc

